"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WSPaymentStatus = exports.PaymentIntentStatus = exports.PaymentStatus = exports.ChargeStatus = exports.InvoiceStatus = exports.SubscriptionStatus = exports.SubscriptionTermRank = exports.SubscriptionPackageTierRank = exports.SubscriptionPackageRank = exports.SubscriptionGrantStatus = exports.SubscriptionPackageTier = exports.SubscriptionPackage = exports.SubscriptionTerm = exports.PackageUpdateIntent = exports.PlanInterval = void 0;
var PlanInterval;
(function (PlanInterval) {
    PlanInterval["day"] = "day";
    PlanInterval["week"] = "week";
    PlanInterval["month"] = "month";
    PlanInterval["year"] = "year";
})(PlanInterval = exports.PlanInterval || (exports.PlanInterval = {}));
var PackageUpdateIntent;
(function (PackageUpdateIntent) {
    PackageUpdateIntent["Upgrade"] = "Upgrade";
    PackageUpdateIntent["Downgrade"] = "Downgrade";
    PackageUpdateIntent["None"] = "None";
})(PackageUpdateIntent = exports.PackageUpdateIntent || (exports.PackageUpdateIntent = {}));
;
var SubscriptionTerm;
(function (SubscriptionTerm) {
    SubscriptionTerm["Yearly"] = "Yearly";
    SubscriptionTerm["Monthly"] = "Monthly";
})(SubscriptionTerm = exports.SubscriptionTerm || (exports.SubscriptionTerm = {}));
;
var SubscriptionPackage;
(function (SubscriptionPackage) {
    SubscriptionPackage["None"] = "None";
    SubscriptionPackage["Benefits"] = "Benefits";
    SubscriptionPackage["Essentials"] = "Essentials";
    SubscriptionPackage["Professional"] = "Professional";
    SubscriptionPackage["Corporate"] = "Corporate";
})(SubscriptionPackage = exports.SubscriptionPackage || (exports.SubscriptionPackage = {}));
;
var SubscriptionPackageTier;
(function (SubscriptionPackageTier) {
    SubscriptionPackageTier["Basic"] = "Basic";
    SubscriptionPackageTier["Premium"] = "Premium";
})(SubscriptionPackageTier = exports.SubscriptionPackageTier || (exports.SubscriptionPackageTier = {}));
;
var SubscriptionGrantStatus;
(function (SubscriptionGrantStatus) {
    SubscriptionGrantStatus["Pending"] = "Pending";
    SubscriptionGrantStatus["Active"] = "Active";
    SubscriptionGrantStatus["Canceled"] = "Canceled";
})(SubscriptionGrantStatus = exports.SubscriptionGrantStatus || (exports.SubscriptionGrantStatus = {}));
;
exports.SubscriptionPackageRank = {
    [SubscriptionPackage.None]: 0,
    [SubscriptionPackage.Benefits]: 100,
    [SubscriptionPackage.Essentials]: 200,
    [SubscriptionPackage.Professional]: 300,
    [SubscriptionPackage.Corporate]: 400
};
exports.SubscriptionPackageTierRank = {
    [SubscriptionPackageTier.Basic]: 0,
    [SubscriptionPackageTier.Premium]: 100
};
exports.SubscriptionTermRank = {
    [SubscriptionTerm.Monthly]: 0,
    [SubscriptionTerm.Yearly]: 100
};
;
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["incomplete"] = "incomplete";
    SubscriptionStatus["incomplete_expired"] = "incomplete_expired";
    SubscriptionStatus["trialing"] = "trialing";
    SubscriptionStatus["active"] = "active";
    SubscriptionStatus["past_due"] = "past_due";
    SubscriptionStatus["canceled"] = "canceled";
    SubscriptionStatus["unpaid"] = "unpaid";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["draft"] = "draft";
    InvoiceStatus["open"] = "open";
    InvoiceStatus["paid"] = "paid";
    InvoiceStatus["uncollectible"] = "uncollectible";
    InvoiceStatus["void"] = "void";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var ChargeStatus;
(function (ChargeStatus) {
    ChargeStatus[ChargeStatus["succeeded"] = 0] = "succeeded";
    ChargeStatus[ChargeStatus["pending"] = 1] = "pending";
    ChargeStatus[ChargeStatus["failed"] = 2] = "failed";
})(ChargeStatus = exports.ChargeStatus || (exports.ChargeStatus = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Succeeded"] = "Succeeded";
    PaymentStatus["ActionRequired"] = "ActionRequired";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
;
var PaymentIntentStatus;
(function (PaymentIntentStatus) {
    PaymentIntentStatus["requires_payment_method"] = "requires_payment_method";
    PaymentIntentStatus["requires_confirmation"] = "requires_confirmation";
    PaymentIntentStatus["requires_action"] = "requires_action";
    PaymentIntentStatus["processing"] = "processing";
    PaymentIntentStatus["requires_capture"] = "requires_capture";
    PaymentIntentStatus["canceled"] = "canceled";
    PaymentIntentStatus["succeeded"] = "succeeded";
})(PaymentIntentStatus = exports.PaymentIntentStatus || (exports.PaymentIntentStatus = {}));
exports.WSPaymentStatus = {
    [PaymentIntentStatus.succeeded]: PaymentStatus.Succeeded,
    [PaymentIntentStatus.canceled]: PaymentStatus.Failed,
    [PaymentIntentStatus.requires_payment_method]: PaymentStatus.Failed,
    [PaymentIntentStatus.requires_action]: PaymentStatus.ActionRequired
};
;
;
;
//# sourceMappingURL=subscription.js.map